import { ISupplier } from "__graphql__/types";

import { Supplier } from "./types";

export const serializeSupplier = ({
  id,
  name,
  externalId,
  sortSequence,
}: Pick<ISupplier, "id" | "name" | "sortSequence" | "externalId">): Supplier => ({
  id,
  name,
  externalId,
  sortSequence: sortSequence ?? null,
});
